<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('copyBatch') }}</h5>
                    <button type="button" class="btn-close" @click="$emit('close')" :disabled="copying"></button>
                </div>
                <div class="modal-body">
                    <div v-if="!copying && !result">
                        <div class="mb-3">
                            <label class="form-label small fw-bold">{{ $t('newBatchName') }}</label>
                            <input type="text" class="form-control form-control-sm" v-model="newName" />
                        </div>
                    </div>
                    <div v-if="copying" class="text-center py-3">
                        <div class="spinner-border text-primary mb-2" role="status"></div>
                        <div class="text-muted">{{ $t('copying') }}...</div>
                    </div>
                    <div v-if="result" class="text-center py-3">
                        <i :class="result === 'success' ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'" style="font-size: 32px"></i>
                        <div class="mt-2">{{ resultMessage }}</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button v-if="result" type="button" class="btn btn-secondary" @click="$emit('close')">
                        {{ $t('close') }}
                    </button>
                    <template v-if="!copying && !result">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            {{ $t('cancel') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="copy" :disabled="!newName.trim()">
                            <i class="fas fa-copy"></i> {{ $t('confirm') }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>

<script>
import DataBatchApi from '../../api/server/databatch';

export default {
    name: 'DataBatchCopyModal',
    props: {
        batch: { type: Object, required: true }
    },
    data() {
        return {
            copying: false,
            result: null,
            resultMessage: '',
            newName: this.batch.name + ' (copy)'
        };
    },
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        }
    },
    methods: {
        async copy() {
            this.copying = true;
            this.result = null;
            try {
                var content = { ...this.batch, name: this.newName.trim() };
                delete content.id;
                await DataBatchApi.dataBatchCreate(this.dataSpaceId, content);
                this.result = 'success';
                this.resultMessage = this.$t('batchCopySuccessful');
            } catch (error) {
                this.result = 'error';
                var key = error?.response?.body?.message || 'unknownError';
                this.resultMessage = this.$t(key);
            } finally {
                this.copying = false;
                this.$emit('reload');
            }
        }
    }
};
</script>